import React from 'react';
import { useDrawerManager } from 'features/command-center/contexts';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { DRAWERS_CONFIG } from './Drawers.constants';
import { useDrawerStyles } from './Drawers.styled';

export const Drawers = ({ prefixTitle = '', suffixTitle = '' }) => {
  const drawerManager = useDrawerManager();
  const { drawerLarge } = useDrawerStyles();

  if (!Object.keys(DRAWERS_CONFIG).includes(drawerManager.drawerState.activeDrawer)) {
    return null;
  }

  const drawerConfig = DRAWERS_CONFIG[drawerManager.drawerState.activeDrawer];
  const Component = drawerConfig?.component;
  const title = `${prefixTitle ? `${prefixTitle} ` : ''}${
    drawerConfig?.title || ''
  } ${suffixTitle}`;

  return (
    <FPDrawer
      CardHeaderProps={{ title, subheader: drawerConfig?.subHeader }}
      FPDrawerProps={{
        open: drawerManager.drawerState.isOpen,
        classes: { paper: drawerLarge }
      }}
      onClose={drawerManager.closeDrawer}
      hasPaddingContent={false}
    >
      <Component {...drawerManager.drawerState.contentProps} />
    </FPDrawer>
  );
};
